import { render } from "./LoanView.vue?vue&type=template&id=f286b296"
import script from "./LoanView.vue?vue&type=script&lang=js"
export * from "./LoanView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__